import { GridAggregationFunction } from '@sbv-clients/ui-shared';

import { EmployeesRowType, RegularUniqueSum } from './employees-columns';

export const sumBothNotified: GridAggregationFunction<
  RegularUniqueSum,
  RegularUniqueSum
> = {
  label: 'sumBothNotified',
  getCellValue: ({ row }) => ({
    regular: (row as EmployeesRowType).notified || 0,
    unique: (row as EmployeesRowType).uniqueNotified || 0,
  }),
  apply: ({ values }) => {
    let regular = 0;
    let unique = 0;
    values.forEach((value) => {
      if (value) {
        regular += value.regular;
        unique += value.unique;
      }
    });
    return { regular, unique };
  },
  columnTypes: ['number'],
};

export const sumBothAssigned: GridAggregationFunction<
  RegularUniqueSum,
  RegularUniqueSum
> = {
  label: 'sumBothAssigned',
  getCellValue: ({ row }) => ({
    regular: (row as EmployeesRowType).assigned || 0,
    unique: (row as EmployeesRowType).uniqueAssigned || 0,
  }),
  apply: ({ values }) => {
    let regular = 0;
    let unique = 0;
    values.forEach((value) => {
      if (value) {
        regular += value.regular;
        unique += value.unique;
      }
    });
    return { regular, unique };
  },
  columnTypes: ['number'],
};

export const ratio: GridAggregationFunction<
  boolean,
  {
    top: number;
    bottom: number;
  }
> = {
  label: 'ratio',
  getCellValue: () => true,
  apply: ({ values }) => {
    let top = 0;
    let bottom = 0;
    values.forEach((value) => {
      top += value ? 1 : 0;
      bottom += 1;
    });
    return { top, bottom };
  },
  columnTypes: ['boolean'],
};

export const noop: GridAggregationFunction = {
  label: 'noop',
  apply: () => undefined,
};
